export default "__VITE_ASSET__BFyXuJ96__"